import { useContext } from 'react';
import { Theme, ThemeContext } from 'context';

const useTheme = (): Theme => useContext(ThemeContext);

export default useTheme;
